import * as React from "react";
import { connect } from "react-redux";

import { RootState } from "../../state";
import { featuredProjectsSelector, companySelector } from "../selectors";
import { Project, Company } from "../entities";
import ProjectsSection from "./ProjectsSection";

interface OwnProps {
  editable?: boolean;
  locale: string;
}

interface MappedProps {
  projects: Project[];
  company: Company;
}

type Props = MappedProps & OwnProps;

const ProjectsSectionContainer: React.SFC<Props> = props => {
  const { projects, company, editable, locale } = props;
  return <ProjectsSection projects={projects} company={company} editable={editable} locale={locale} />;
};

function mapStateToProps(state: RootState): MappedProps {
  const projects = featuredProjectsSelector(state);
  const company = companySelector(state)!;
  return { projects, company };
}

export default connect(mapStateToProps)(ProjectsSectionContainer);



// WEBPACK FOOTER //
// ./frontend/src/companies/components/ProjectsSectionContainer.tsx